/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
const INITIAL_STATE = {
  step: 1,
  document: null,
  customerCode: null,
  url: null,
  contactId: null,
  contactName: null,
  smsToken: null,
  newEmail: null,
  lastInvoiceNumber: null,
  penultimateInvoiceNumber: null,
};

const signUpReducer = (state = INITIAL_STATE, action) => {
  const { type } = action;
  if (type === 'TOGGLE_SIGNUP_STEP') {
    return {
      ...state,
      step: action.step,
    };
  }
  if (type === 'REGISTER_CONTACT_ID') {
    return {
      ...state,
      contactName: action.contactName,
      contactId: action.contactId,
    };
  }
  if (type === 'REGISTER_CUSTOMER_DOCUMENT') {
    return {
      ...state,
      document: action.document,
      customerCode: action.customerCode,
      siteId: action.siteId,
      userId: action.userId,
    };
  }
  if (type === 'REGISTER_INVOICE_NUMBER') {
    return {
      ...state,
      lastInvoiceNumber: action.lastInvoiceNumber,
      penultimateInvoiceNumber: action.penultimateInvoiceNumber,
    };
  }
  if (type === 'CREATE_URL_HATEOAS') {
    return {
      ...state,
      url: action.url,
    };
  }
  if (type === 'REGISTER_SMS_TOKEN') {
    return {
      ...state,
      smsToken: action.token,
    };
  }
  if (type === 'RESET_SIGNUP_STATE') {
    return {
      ...state,
      step: 1,
      document: null,
      customerCode: null,
      url: null,
      contactId: null,
      contactName: null,
      smsToken: null,
      newEmail: null,
      lastInvoiceNumber: null,
      penultimateInvoiceNumber: null,
    };
  }
  return {
    ...state,
  };
};

export default signUpReducer;
